import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {

  public APIConfig = {
    ACCOUNTDELETE: 'webapi-account-delete',
    GETUSERACCOUNTDELETE: 'webapi-get-account-delete',
    SEARCHUSERACCOUNTDELETE: 'webapi-search-account-delete',
    ACCOUNT:'api-account',
    SIGNIN: 'api-signin',
    GETXMLDATA: 'api-getArticleList',
    GETARTICLELIST: 'webapi-article-list',
    GETARTICLELISTSNEWS: 'webapi-article-lists',
    GETARTICLEBYNODEALIAS: 'webapi-articalnodealiasWeb',
    GETARTICLEBYCATEGORY: 'webapi-categoryaliasdataWeb',
    GETHEADLINEDATA: 'api-headlinesWeb',
    GETTRANDINGDATA: 'api-tranding',
    GETCATEGORYlIST: 'api-categorylist',
    GETSEARCHARTICLE: 'api-search',
    GETPUBLISHERBYARTICLE:'api-publisher',

    // ADMIN //
    GETCONTENT: 'api-content',
    GETSEARCHARTICLEADMIN: 'api-searchArticle',
    GETWEBARTICLEADMIN:'webapi-article-listWeb',
    GETUSERLIST: 'api-getlogindata',
    GETUSERLISTDATA: 'webapi-user-listWeb',
    ADDCONTENT: 'api-addArticle',
    INSTA: 'getInsta',
    GETCATEGORYLISTS: 'api-web-categoryListWeb',
    UPDATEWEBCATEGORY: 'api-updatewebtaxonomy',
    DELETEWEBCATEGORY: 'api-deletewebtaxonomy',
    ADDCATEGORY: 'api-addwebtaxonomyWeb',
    GETCATSTATUS: 'api-categoryStatus',
    SEARCHCATEGORY: 'api-searchCategory',
    UPDATEARTICLE:'api-updatearticlelist',
    DELETEARTICLE:'api-deletearticlelist',
    USERSIGNUP:'api-signup',
    USERFILTERLIST:'api-userFilterList',
    USERSEARCH:'api-userSearch',
    ADMINUSERSIGNUP:'webapi-signupWeb',
    LISTOFNODES:'webapi-list-of-nodes',
    LISTOFNODESFILTER:'webapi-list-of-nodes-filter',
    EPISODELISTOFNODES:'webapi-episode-list-of-nodes',
    EPISODELISTOFNODESFILTER:'webapi-episode-list-of-nodes-filter',
    PUSHNOTIFICATION:'webapi-user-push-notification',
    UPDATEUSERADMIN:'webapi-userUpdateWeb',

    ADDMETAPAGE:'api-addmetapage',
    GETMETAPAGE:'api-getmetapage',
    UPDATEMETAPAGE:'api-updatemetapage',
    DELETEMETAPAGE:'api-deletemetapage',

    ADDAPPVERSION:'api-addappdetails',
    GETAPPVERSION:'api-getappdetailslist',
    UPDATEAPPVERSION:'api-updateappdetails',
    DELETEAPPVERSION:'api-deleteappdetails',
    FILTERAPPVERSION:'api-filterMetaPage',

    MULARTICLEUPDATE:'webapi-del-updateWeb',
    USERSTATUSUPDATE:'webapi-userstatusupdateWeb',
    GETPAGES:'api-getpages',
    FILTERMETAPAGE:'api-filterMetaPage',
    GETROLES:'api-getRoleList',
    ADDPAGESFORMETA:'api-addpage',
    GETMETADATABYTITLE:'api-getMetaDataByTitle',
    DASHBOARDCOUNTDATA:'api-dashboard_count_data',

    ADDWEBMASTER:'api-addwebmaster',
    GETWEBMASTER:'api-getwebmaster',
    UPDATEWEBMASTER:'api-updatewebmaster',
    DELWEBMASTER:'api-deletewebmaster',

    GETWEBCAT:'api-getCatListWeb',
    GETWEBCATALL:'api-getwebtaxonomy',
    BLACKHISTORY:'api-blackhistory',
    SENTNOTIFICATIONS:'api-sent-messages',

    DELETEUSER:'api-user-delWeb',
    UPDATEPASSWORD:'api-user-passUpdateWeb',

    USERSETTINGLIST:'webapi-usersetting-listWeb',
    USERSETTINGSEARCH:'webapi-usersetting-searchWeb',
    USERSETTINGADD:'webapi-usersetting-signupWeb',
    USERSETTINGUPDATE:'webapi-usersetting-userUpdateWeb',

    GETARTICLEDETAILPAGEWEB:'webapi-articalnodealiasDetailWeb',
    GETARTICLESBYSTATUS:'webapi-articlePerDayByStatusWeb',
    GETTOP10ARTICLES:'webapi-articles-top10Web',
    
    GETTOP10PODCAST:'webapi-podcast-topWeb',
    
    GETARTICLEBYCATPERDAY:'webapi-articlePerDayByCatWeb',
    GETARTICLEBYPUB:'webapi-articlePerDayByPublisherWeb',
    GETPUBLISHEDARTCILEBYPUB:'webapi-publishedarticlePerDayByPubWeb',
    GETPUBLISHERLIST:'api-getPublisherWeb',
    UPDATENOOFVIEW:'api-updateArticleViewWeb',
    
    UPDATENOOFPODCASTVIEW:'api-updatePodcastViewWeb',

    PUBLISHERFILTER:'api-getPublisherFilterWeb',

    PUSHNOTIFICATIONBYONESIGNAL:'webapi-user-push-notification-one-signal',
    PUSHSCHEDULE:'api-addschedule',
    GETPUSHSCHEDULE:'api-getschedule',
    DELSCHEDULE: 'api-deleteschedule',
    UPDATESCHEDULE: 'api-updateschedule',
    ZEROARTICLEBYPUBLISHER:'webapi-publisherArticleCount',

    //**PODCAST */
    GETPODCAST:'api-podcast',
    SEARCHPODCAST:'api-podcast-searching',

    PODCASTCATEGORY:'api-podcast-category',

    MULTIPLEPODCASTUPDATE:'api-podcast/mul-update',

     // EPISODE//
     GETEPISODE:'webapi-get-episode',
     DELETEEPISODE:'webapi-delete-episode',
     ADDEPISODE:'webapi-add-episode',
     SEARCHEPISODE:'webapi-search-episode',
     MULTIPLEEPISODEUPDATE:'webapi-episode-mul-update',
     PODCASTLISTNAME:'webapi-podcast-list',

     GETPODCASTCATEGORY:'webapi-podcast-category',
    SEARCHPODCASTCATEGORY:'webapi-search-podcast-category-list',

    GETEPISODEDETAIL:'webapi-episode-detail',
    GETPRIVACYPOLICY:'webapi-privacy-policy',
    BANNERIMAGES:'api-banner-image',
    GETPOPULARPODCAST:'api-popular-podcastWeb',
    UPDATEPOPULARPODCAST:'api-popular-podcastUpdateWeb',
    // ADMIN //
    
  //PODCAST//
  GETPODCASTCATEGORYWITHPODCAST:'api-podcast-category/podcastWeb',
  GETPODCASTBYALIAS:'api-podcastWeb/alias',
  GETEPISODEDETAILBYALIAS:'api-episodeWeb/alias',

  GETALLPODCASTBYCATEGORYALIAS:'api-podcast-categoryWeb/alias',
  GETTERMSERVICE:'webapi-terms-of-service',

  GETPUBLISHERTERMS:'webapi-terms-publisher',
  GETPODCASTERSTERMS:'webapi-terms-podcaster',

  POPULARPODCAST:'webapi-popular-podcast',
  SEARCHPODCASTNAME:'api-podcastWeb/search',
  CATTHUMBPODCAST:'webapi-category-thumb-podcast',

  GETPRESSMEDIAARTICLE:'webapi-article-press-media',

  ADDARTICLEPRESSMEDIA:'webapi-addPressMediaArticle',
  ADMINGETPRESSMEDIAARTICLE:'webapi-article-press-mediaWeb',

  ADMINUPDATEPRESSMEDIA:'webapi-updatePressMediaArticle',
  ADMINDELPRESSMEDIA:'webapi-deletePressMediaArticle',

  ADMINARTICLESEARCHPRESS:'webapi-article-press-search',
  ADMINMULPRESSMEDIAARTICLEUPDATE:'webapi-article-press-updateWeb',

  GETHAYTINEWSDETAILS:'webapi-articalnodealiasWebHaytiNews',

  GETPODCASTARTICLENEWS:'api-podcast-articles-web',
  GETALLPODCASTARTICLENEWS:'webapi-articlelistbypodcastcategory',
  GETPODCASTCATEGORYLIST:'api-podcast-category-web'
  }

  constructor() { }
}
